var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1042 12.5748L24.6308 20.0001L32.1042 27.4254C32.2393 27.1431 32.3212 26.8309 32.3212 26.4975V13.5027C32.3212 13.1693 32.2393 12.8572 32.1042 12.5748ZM30.1554 11.3369H9.845C9.51161 11.3369 9.1995 11.4189 8.91712 11.554L18.4689 21.0577C19.3135 21.9022 20.6869 21.9022 21.5315 21.0577L31.0833 11.554C30.8009 11.4189 30.4888 11.3369 30.1554 11.3369ZM7.89626 12.5748C7.76116 12.8572 7.6792 13.1693 7.6792 13.5027V26.4975C7.6792 26.8309 7.76116 27.1431 7.89626 27.4254L15.3697 20.0001L7.89626 12.5748Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6103 21.021L22.5527 22.0785C21.1455 23.4858 18.8556 23.4858 17.4484 22.0785L16.3909 21.021L8.91748 28.4463C9.19985 28.5814 9.51197 28.6633 9.84536 28.6633H30.1558C30.4892 28.6633 30.8013 28.5814 31.0837 28.4463L23.6103 21.021Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.0929f927.svg";
export { ForwardRef as ReactComponent };